import React from "react";

const Leg = () => (
  <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 0V2.76772C0 4.21783 1.77351 4.92116 2.76736 3.86519L5.45681 1.00765C6.06097 0.365738 6.90294 0.00127805 7.7843 3.35493e-06C5.30942 2.53165e-06 2.69058 1.4328e-06 0 0Z"
      fill="#E44258"
    />
  </svg>
);

Leg.displayName = "Leg";

export default Leg;
